import C from "../actionTypes";

export const careerData = (state = {}, action) => {
    switch (action.type) {
        case C.CAREER_DATA_REQUEST:
            return {};
        case C.CAREER_DATA_SUCCESS:
            return action.careerData;
        case C.CAREER_DATA_FAILURE:
            return state;
        default :
            return state
    }
};

export const careerGameType = (state = '', action) => {
    switch (action.type) {
        case C.GET_CAREER_DATA:
            return action.careerGameType;
        case C.CAREER_DATA_FAILURE:
            return state;
        default :
            return state
    }
};


export const careerSelectedClub = (state = '', action) => {
    switch (action.type) {
        case C.GET_CAREER_DATA:
            return action.careerSelectedClub;
        case C.CAREER_DATA_FAILURE:
            return state;
        default :
            return state
    }
};

export const careerCurrentDate = (state = '', action) => {
    switch (action.type) {
        case C.GET_CAREER_DATA:
            return action.careerCurrentDate;
        case C.CAREER_DATA_FAILURE:
            return state;
        default :
            return state
    }
};

export const careerMenu = (state = false, action) => {
    switch (action.type) {
        case C.TOGGLE_CAREER_MENU:
            return !state;
        default :
            return state
    }
};
